import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ItemDetails } from '../models/propertyByIdResponse';
import { ContractA } from '../models/contractA.interface';

@Injectable({
  providedIn: 'root'
})
export class PropertyKeeperService {
  public readonly propertyFormData$: BehaviorSubject<ItemDetails | null> = new BehaviorSubject<ItemDetails | null>(null);
  public readonly contractA$: BehaviorSubject<ContractA | null> = new BehaviorSubject<ContractA | null>(null);
}